import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '../../../../_metronic/i18n/Metronici18n'
import { NotasVersaoListWrapper } from './notas-versao-list/NotasVersaoList'

const NotasVersaoPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.notas_versao.descricao')}>
              {t('menu.nav.notas_versao')}
            </PageTitle>
            <NotasVersaoListWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default NotasVersaoPage
